import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-[20px]" }, "優惠卷", -1)
const _hoisted_2 = { class: "flex justify-between items-center mb-[26px]" }
const _hoisted_3 = { class: "w-full pr-2 sm:pr-0 sm:w-[320px]" }
const _hoisted_4 = { class: "hidden" }
const _hoisted_5 = { class: "max-h-[350px] flex flex-col mt-[30px] gap-2.5 overflow-auto" }
const _hoisted_6 = { class: "flex flex-col h-[104px] justify-center" }
const _hoisted_7 = {
  key: 0,
  class: "text-sm font-medium text-gary-text-color"
}
const _hoisted_8 = {
  key: 1,
  class: "text-sm font-medium text-gary-text-color"
}
const _hoisted_9 = { class: "text-xs text-gary-text-color" }
const _hoisted_10 = {
  key: 2,
  class: "text-[11px] text-light-gary-text-color"
}
const _hoisted_11 = {
  key: 3,
  class: "text-[11px] text-secondary-color"
}
const _hoisted_12 = {
  key: 4,
  class: "tracking-[.08em] text-[11px] text-secondary-color"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 再消費 ")
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 可使用此卷 ")
const _hoisted_16 = { class: "my-auto" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gary-line-color mt-[12px]" }, [
  /*#__PURE__*/_createTextVNode(" 單筆訂單限抵一張折價券。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 取消訂單、辦理整筆退貨或退貨後之保留商品未符合折價券使用條件時，若折價券能仍在使用期限內，將歸還至帳戶中。 ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_ModalBase = _resolveComponent("ModalBase")!

  return (_openBlock(), _createBlock(_component_ModalBase, {
    show: _ctx.show,
    class: "g-address-modal modal-510-width"
  }, {
    body: _withCtx(() => [
      _createVNode(_component_Icon, {
        iconName: "modal-close",
        class: "absolute top-4 right-4 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:show', false)))
      }),
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Input, {
            class: "w-full",
            width: '100%',
            placeholder: "請輸入優惠代碼",
            modelValue: _ctx.promotionCode,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.promotionCode) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", {
          class: "bg-gary-text-color text-sm text-white w-[60px] h-[40px] text-center leading-[40px] rounded-md cursor-pointer",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.redeemCode()))
        }, " 確認 ")
      ]),
      false
        ? (_openBlock(), _createBlock(_component_Tabs, {
            key: 0,
            data: [
          { id: 1, text: '優惠卷' },
          { id: 2, text: '運費抵用卷' },
        ],
            customClass: 'custom-coupon-tabs',
            onTabSelect: _ctx.tabSelect
          }, null, 8, ["onTabSelect"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Divider)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cmdyCouponListRef, (cmdyCoupon, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["w-full flex justify-between px-[16px] rounded-md border-[1px] border-black-300-color", {
            'border-black-300-color': !cmdyCoupon.IsUsing,
            'border-primary-color': cmdyCoupon.IsUsing,
            'bg-black-200-color':
              !cmdyCoupon.IsAvailable && !cmdyCoupon.IsUsing,
          }])
          }, [
            _createElementVNode("div", _hoisted_6, [
              (cmdyCoupon.DiscountAmount !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 折 NT. " + _toDisplayString(cmdyCoupon.DiscountAmount), 1))
                : _createCommentVNode("", true),
              (cmdyCoupon.DiscountPercentage !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(cmdyCoupon.DiscountPercentage * 10) + " 折 ", 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, _toDisplayString(cmdyCoupon.PromotionCouponName), 1),
              (!_ctx.calcDateIsLimit(cmdyCoupon.EffectiveDateEnd))
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 有效期限：" + _toDisplayString(_ctx.moment
                  .utc(
                    _ctx.moment
                      .utc(cmdyCoupon.EffectiveDateEnd, "YYYYMMDDHHmmss")
                      .local()
                  )
                  .format("YYYY/MM/DD")), 1))
                : _createCommentVNode("", true),
              (_ctx.calcDateIsLimit(cmdyCoupon.EffectiveDateEnd))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, " 即將失效：" + _toDisplayString(_ctx.calcLimitTime(cmdyCoupon.EffectiveDateEnd)), 1))
                : _createCommentVNode("", true),
              (!cmdyCoupon.IsReachThreshold)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("span", _hoisted_14, "NT." + _toDisplayString(cmdyCoupon.ThresholdDifference), 1),
                    _hoisted_15
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              (!cmdyCoupon.IsUsing)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: ($event: any) => (cmdyCoupon.IsAvailable && _ctx.choseCoupon(cmdyCoupon)),
                    class: _normalizeClass(["w-[80px] h-[30px] text-white text-xs text-center leading-[30px] rounded-md cursor-pointer", {
                'bg-black-300-color': !cmdyCoupon.IsAvailable,
                'bg-gary-text-color': cmdyCoupon.IsAvailable,
                'cursor-not-allowed': !cmdyCoupon.IsAvailable,
                'hover:bg-primary-color': cmdyCoupon.IsAvailable,
                'active:bg-primary-color': cmdyCoupon.IsAvailable,
              }])
                  }, " 使用 ", 10, _hoisted_17))
                : _createCommentVNode("", true),
              (cmdyCoupon.IsUsing)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    onClick: ($event: any) => (_ctx.choseCoupon(cmdyCoupon)),
                    class: "w-[80px] h-[30px] text-white text-xs bg-primary-color text-center leading-[30px] rounded-md cursor-pointer"
                  }, " 使用中 ", 8, _hoisted_18))
                : _createCommentVNode("", true)
            ])
          ], 2))
        }), 128))
      ]),
      _hoisted_19
    ]),
    _: 1
  }, 8, ["show"]))
}